/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

const PROPOSALS_URL = '/api/prestation/proposal/list/'
const PROPOSAL_URL = '/api/prestation/proposal/'
const PROPOSAL_VALIDATION_URL = '/api/prestation/proposal/validation/'
const PROPOSAL_WORKFLOW_URL = '/api/prestation/proposal/workflow/'
const PRESTATION_PROPOSAL_ACTION_URL = '/api/prestation/proposal/action/'

export const getPrestationProposals = (query) => {
  query = {
    ...query,
    meta: false,
    objects_count: false,
  }

  return Request.getRequest(PROPOSALS_URL + '?' + qs.stringify(query))
    .then((result) => {
      return result
    })
}

export const getPrestationProposal = (uid) => {
  return Request.getRequest(PROPOSAL_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export const postPrestationProposalValidation = (data, uid) => {
  return Request.postRequest(PROPOSAL_VALIDATION_URL + (uid ? uid + '/' : ''), data)
}

export const postPrestationProposal = (data, uid) => {
  return Request.postRequest(PROPOSAL_URL + (uid ? uid + '/' : ''), data)
}

export const executePrestationProposalOperation = (uid, data) => {
  return Request.postRequest(PROPOSAL_WORKFLOW_URL + '?target=' + uid, data)
    .catch((error) => {
      throw error.response
    })
}

export function getPrestationProposalAction(token) {
  return Request.getRequest(PRESTATION_PROPOSAL_ACTION_URL + token + '/')
    .catch((error) => {
      throw error.response
    })
}

export function postPrestationProposalAction(token) {
  return Request.postRequest(PRESTATION_PROPOSAL_ACTION_URL + token + '/', {})
    .catch((error) => {
      throw error.response
    })
}



// WEBPACK FOOTER //
// ./src/actions/Proposal.js